export function get会員種別コード(会員種別名){
    switch(会員種別名){
        case '企業会員':
            return 10010002;

        case '団体会員':
            return 10010003;

        case '公共会員':
            return 10010004;

        case '団体所属会員':
            return 10010005;
        
        case '賛助会員':
            return 10010006;
        
        default:
            return '';
    }
}
